// extracted by mini-css-extract-plugin
export default {"question_box":"QuestionBox_question_box__cK33K","question_text":"QuestionBox_question_text__XJC9e"};